import axios from 'axios';
export default class TrainingProviderService {
    all () {
        return axios.get(`${process.env.VUE_APP_RUTA_API}/training-providers`).then(res => {
            return res.data;
        });
    }

    create (data) {
        return axios.post(`${process.env.VUE_APP_RUTA_API}/training-providers`, data).then(res => {
            return res.data;
        });
    }

    update (data, id) {
        return axios.put(`${process.env.VUE_APP_RUTA_API}/training-providers/${id}`, data).then(res => {
            return res.data;
        });
    }

    delete (id) {
        return axios.delete(`${process.env.VUE_APP_RUTA_API}/training-providers/${id}`).then(res => {
            return res.data;
        });
    }

    search (searchTerm) {
        return axios.get(`${process.env.VUE_APP_RUTA_API}/training-providers/search/${searchTerm}`).then(res => {
            return res.data;
        });
    }

    importExcel (file) {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(`${process.env.VUE_APP_RUTA_API}/training-providers/import/excel`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then(res => {
            return res.data;
        });
    }
}
